import React from 'react';

const CurrencyRenderer = <TItem extends { [key: string]: any }>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    const raw = item[colKey];

    // Normalize to a number so unrounded API values (e.g. 7991.044) format to 2 decimals
    const num = typeof raw === 'number' ? raw : Number(String(raw ?? '').replace(/[^0-9.-]/g, ''));

    if (raw === null || raw === undefined || raw === '' || Number.isNaN(num)) {
        return <>{''}</>;
    }

    return <>{num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>;
};

export default CurrencyRenderer;
